import React from "react"

export default function NewDeviceField ({ label, children }) {
    return (
        <div className='new-device-field'>
            <p>{label}</p>
            {children}
        </div>
    )
}
